import {
	SET_CATEGORY_SELECTION_START,
	SET_CATEGORY_SELECTION_SUCCESS,
	SET_CATEGORY_SELECTION_FAIL,
} from 'client/constants';

export function setCategorySelection({ categoryId, selectedItems }) {
	return async dispatch => {
		try {
			dispatch({ type: SET_CATEGORY_SELECTION_START, payload: { categoryId, selectedItems } });

			const ls = window.localStorage;
			const fieldName = `${categoryId}v2`;
			const currentData = JSON.parse(
				ls.getItem(fieldName) ||
					'{ "isSelectionSubmitted": false, "isInfoSubmitted": false, "selectedItems": [] }'
			);
			const updatedData = { ...currentData, selectedItems };

			ls.setItem(fieldName, JSON.stringify(updatedData));

			dispatch({ type: SET_CATEGORY_SELECTION_SUCCESS, payload: { categoryId, selection: updatedData } });
		} catch (e) {
			dispatch({ type: SET_CATEGORY_SELECTION_FAIL, payload: e.message });
		}
	};
}
